import Hero from "../../designSystem/Hero";
// import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import MortgageRepaymentCalculator from "../../calculators/MortgageRepaymentCalculator";
import SEO from "../../designSystem/SEO";

const MortgageRepaymentCalculatorsPage = () => {
  return (
    <div>
      <SEO
        title="Mortgage Repayment Calculator"
        description="Estimate monthly mortgage repayments by entering your loan amount, term and interest rate with the AK Mortgages repayment calculator."
        path="/calculators/mortgage-repayment"
      />
      <Hero
        title="SEE WHAT YOUR MONTHLY PAYMENTS MIGHT LOOK LIKE"
        subtitle="Repayment Calculator"
        showContactButton={false}
        // backgroundImage={CalculatorsImag1}
      >
        <div className="column-center gap-s">
          <div className="content text-primary-1">
            Understanding what your monthly mortgage payments could look like is
            an important part of planning your property journey. Our mortgage
            repayment calculator lets you explore different loan amounts,
            mortgage terms, and interest rates to see how they may affect your
            monthly repayments. 
          </div>
        </div>
      </Hero>
      <MortgageRepaymentCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageRepaymentCalculatorsPage;
